import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-1qwsvpk-0"
})(["display:inline-block;position:relative;width:auto;cursor:pointer;&:after{display:block;position:relative;border-top:1px solid ", ";content:'';}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});